import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

class AdminExportHeader extends PureComponent {
  render() {
    const {
      intl,
      exportsVisible,
      exportsTotal,
      loading,
    } = this.props;

    return (
      <div className="header-actions exports-actions">
        <div className="items-displaying exports-displaying">
          {!loading && (
            <span>
              {intl.formatMessage(
                { defaultMessage: '{exportsVisible} of {exportsTotal} exports' },
                { exportsVisible, exportsTotal },
              )}
            </span>
          )}
        </div>
      </div>
    );
  }
}

AdminExportHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  exportsVisible: PropTypes.string.isRequired,
  exportsTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default injectIntl(AdminExportHeader);
